export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return (
    error.name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/.test(error.message) ||
    /Failed to fetch dynamically imported module/.test(error.message)
  );
}
